<template>
<md-layout md-column class="elections-3d">
  <md-toolbar id="navbar" class="md-whiteframe md-whiteframe-3dp">
    <div class="md-logo">
      <a href="https://koumoul.com/" style="text-decoration:none;">
        <md-layout md-row>
          <logo :colors="['#0091EA', '#80D8FF']"></logo>
          <h2 style="margin-left:8px;margin-top:18px;color:white;">Koumoul</h2>
        </md-layout>
      </a>
    </div>
    <md-layout md-flex></md-layout>
    <h1>Élection présidentielle du 7 mai 2017 - 2ème tour</h1>
    <md-layout md-flex></md-layout>
  </md-toolbar>
  <md-snackbar md-position="top center" ref="snackbar" :md-duration="12000">
    <ul style="list-style-type:none;margin:0;">
      <li>Utilisez le zoom pour passer entre les niveaux régions, départements et communes.</li>
      <li>Cliquez sur les éléments de la légende pour visualiser les scores d'un candidat.</li>
      <li>Cliquez sur une zone de la carte pour afficher les informations détaillées.</li>
    </ul>
    <md-button @click.native="$refs.snackbar.close()" class="md-raised">ok</md-button>
  </md-snackbar>
  <p class="md-subheader" v-if="!mbglSupported">Malheureusement votre navigateur ne supporte pas l'outil de cartographie utilisé par cette application.</p>
  <p class="md-subheader" v-if="error429">Il semble que vous ayez atteint votre limite d'utilisation du service pour la journée.&nbsp;<a href="https://koumoul.com/t/">Augmenter cette limite.</a></p>
  <md-layout style="flex:1" v-if="mbglSupported && !error429">
    <div class="map-container">
      <div id="map"></div>
      <md-whiteframe class="legend">
        <md-layout md-column>
          <ul>
            <li><md-button @click.native="selectCandidat('abstentions')" v-if="!candidat || candidat === 'abstentions'" :class="candidat === 'abstentions' ? 'md-raised' : ''"><div class="legend-color" style="background-color:#9E9E9E"></div>Abstentions (25,3%)</md-button></li>
            <li><md-button @click.native="selectCandidat('blancsnuls')" v-if="!candidat || candidat === 'blancsnuls'" :class="candidat === 'blancsnuls' ? 'md-raised' : ''"><div class="legend-color" style="background-color:#9E9E9E"></div>Blancs et nuls (8,8%)</md-button></li>
          </ul>
          <span v-if="!candidat"><md-subheader style="padding-left:8px">Votes exprimés (75,78%) :</md-subheader></span>
          <ul style="padding-left:8px">
            <li v-for="c in candidatsArray" v-if="!candidat || candidat === c.id"><md-button @click.native="selectCandidat(c.id)" :class="candidat === c.id ? 'md-raised' : ''"><div class="legend-color" :style="'background-color:' + c.color"></div>{{c.lib}} ({{c.score.toLocaleString()}}%)</md-button></li>
          </ul>
          <md-layout md-row v-if="candidat && stops[level]" style="margin-top:10px;">
            <div class="gradient" :style="`background: linear-gradient(to bottom, ${stops[level].map(s => s[1]).join(',')})`"></div>
            <ul style="padding-left:8px">
              <li v-for="stop in stops[level]">{{stop[0].toLocaleString()}}</li>
            </ul>
          </md-layout>
        </md-layout>
      </md-whiteframe>
    </div>
  </md-layout>

  <md-sidenav class="md-right md-fixed" ref="detailsSidenav">
    <md-toolbar>
      <div class="md-toolbar-container">
        <h3 class="md-title">{{currentDetails.nom}}</h3>
      </div>
    </md-toolbar>
    <div style="padding-left: 8px;">
      <p>{{(currentDetails['presidentielle2017tour2.inscrits'] || '').toLocaleString()}} inscrits</p>
      <p :style="'font-weight:' + (candidat === 'abstentions' ? 'bold' : 'normal')">{{(currentDetails['presidentielle2017tour2.pourcentageabstentions'] || '').toLocaleString()}}% d'abstentions</p>
      <p :style="'font-weight:' + (candidat === 'blancsnuls' ? 'bold' : 'normal')">{{(currentDetails['presidentielle2017tour2.pourcentageblancsnulsinscrits'] || '').toLocaleString()}}% de blancs et nuls</p>
      <p>{{(currentDetails['presidentielle2017tour2.pourcentageexprimesinscrits'] || '').toLocaleString()}}% de votes exprimés répartis ainsi :</p>
      <p v-for="c in currentDetails.candidats" :style="'padding-left:10px;font-weight:' + (c.id === candidat ? 'bold' : 'normal')">{{c.lib}} ({{c.scoreLocal.toLocaleString()}}%)</p>
    </div>
    <md-button class="md-icon-button close-sidenav" @click.native="$refs['detailsSidenav'].close()"><md-icon>close</md-icon></md-button>
  </md-sidenav>
</md-layout>
</template>

<script>
import Logo from './Logo.vue'
const mbglSupported = require('mapbox-gl-supported')()
const mapboxgl = require('mapbox-gl/dist/mapbox-gl.js')
require('mapbox-gl/dist/mapbox-gl.css')
const candidats = require('./candidats.js')
const candidatsArray = Object.keys(candidats).map(id => ({id, ...candidats[id]})).sort((a, b) => b.score - a.score)

const vainqueurFillColor = {
  property: 'presidentielle2017tour2.vainqueurcode',
  type: 'categorical',
  stops: candidatsArray.map(c => [c.id, c.color])
}

export default {
  name: 'app',
  components: {
    Logo
  },
  mounted() {
    this.$ua.trackView('ElectionsCarte')

    if (!this.mbglSupported) return

    setTimeout(() => {
      this.$refs.snackbar.open()
    }, 500)

    this.map = new mapboxgl.Map({
      container: 'map'
    })
    this.map.addControl(new mapboxgl.NavigationControl(), 'top-left')
    this.map.fitBounds([[-5, 41], [10, 51.5]])
    this.$http.get('/s/vt-france/api/v1/fc/style', {params: {
      dataonly: true,
      props: ['presidentielle2017tour2.vainqueurcode', 'presidentielle2017tour2.inscrits', 'presidentielle2017tour2.pourcentageexprimesinscrits', 'presidentielle2017tour2.pourcentageblancsnulsinscrits', 'presidentielle2017tour2.pourcentageabstentions']
        .concat(candidatsArray.map(c => 'presidentielle2017tour2.pourcentagevoixexprimes' + c.id)).join(',')
    }}).then(res => {
      this.style = res.body
      this.map.setStyle(res.body)
    })
    this.map.on('load', () => {
      this.selectCandidat()

      // When a click event occurs on a feature in the places layer, open a popup at the
      // location of the feature, with description HTML from its properties
      this.map.on('click', 'vtfrance-fc-regions-fill', e => {
        console.log('click on "regions" feature', e.features)
        this.selectFeature(e.features[0].properties)
      })
      this.map.on('click', 'vtfrance-fc-departements-fill', e => {
        console.log('click on "departements" feature', e.features)
        this.selectFeature(e.features[0].properties)
      })
      this.map.on('click', 'vtfrance-fc-communes-fill', e => {
        console.log('click on "commune" feature', e.features)
        this.selectFeature(e.features[0].properties)
      })
      this.map.on('error', e => {
        // Forced to ignore other errors. Not mechanism to distinguish "normal" errors from tileserver
        if (e.error && e.error.indexOf('Too Many Requests') !== -1) {
          this.error429 = true
        }
      })

      // Change the cursor to a pointer when the mouse is over the places layer.
      this.map.on('mouseenter', 'vtfrance-fc-regions-fill', () => {
        this.map.getCanvas().style.cursor = 'pointer'
      })

      // Change it back to a pointer when it leaves.
      this.map.on('mouseleave', 'vtfrance-fc-regions-fill', () => {
        this.map.getCanvas().style.cursor = ''
      })
    })
  },
  data: () => ({
    map: null,
    candidats,
    candidatsArray,
    candidat: null,
    currentDetails: {},
    mbglSupported,
    error429: false,
    style: { layers: [] },
    stops: { regions: [], departements: [], communes: [] }
  }),
  computed: {
    zoom() {
      return this.map && this.map.getZoom()
    },
    level() {
      const layer = this.style.layers.find(l => this.zoom >= l.minzoom && this.zoom < l.maxzoom)
      return layer && layer['source-layer']
    }
  },
  methods: {
    selectFeature(properties) {
      this.currentDetails = Object.assign({
        candidats: candidatsArray
          .slice()
          .sort((a, b) => properties['presidentielle2017tour2.pourcentagevoixexprimes' + b.id] - properties['presidentielle2017tour2.pourcentagevoixexprimes' + a.id])
          .map(c => {
            return { scoreLocal: properties['presidentielle2017tour2.pourcentagevoixexprimes' + c.id], ...c }
          })
      }, properties)
      this.$refs.detailsSidenav.open()
    },
    selectCandidat(candidatId) {
      if (!candidatId || this.candidat === candidatId) {
        // toggle off
        this.candidat = null
        this.stops = { regions: [], departements: [], communes: [] }
        this.map.setPaintProperty('vtfrance-fc-regions-fill', 'fill-color', vainqueurFillColor)
        this.map.setPaintProperty('vtfrance-fc-departements-fill', 'fill-color', vainqueurFillColor)
        this.map.setPaintProperty('vtfrance-fc-communes-fill', 'fill-color', vainqueurFillColor)
      } else {
        this.candidat = candidatId
        let property
        let color
        if (candidatId === 'blancsnuls') {
          property = 'presidentielle2017tour2.pourcentageblancsnulsinscrits'
          color = '#9E9E9E'
        } else if (candidatId === 'abstentions') {
          property = 'presidentielle2017tour2.pourcentageabstentions'
          color = '#9E9E9E'
        } else {
          property = 'presidentielle2017tour2.pourcentagevoixexprimes' + candidatId
          color = candidats[candidatId].color
        }

        this.$http.get('/s/vt-france/api/v1/fc/bounds-data', {params: { sum: property }}).then(res => {
          res.body.forEach(bounds => {
            this.stops[bounds.level] = [[0, '#FFFFFF'], [bounds.median, color], [bounds.max, '#222222']]
            this.map.setPaintProperty('vtfrance-fc-' + bounds.level + '-fill', 'fill-color', {
              property,
              type: 'exponential',
              stops: this.stops[bounds.level]
            })
          })
        })
      }
    }
  }
}
</script>

<style lang="less">
html, body {
  height: 100%;
  margin: 0;
}

.md-toolbar {
  align-items: flex-start;
}

.md-toolbar .md-logo {
  text-align: center;
  margin-top: 4px;
  margin-bottom: 4px;
  margin-left: 4px;
}

.logo-container {
  width: 56px;
  height: 56px;
  background-color: white;
  border-radius: 2px;
  box-shadow: inset 0 1px 8px rgba(0, 0, 0, .2), inset 0 3px 4px rgba(0, 0, 0, .14), inset 0 3px 3px -2px rgba(0, 0, 0, .12);
  /*box-shadow: 0 0 6px white;*/
}

.elections-3d {
  height: 100%;
}

.map-container {
  width: 100%;
  #map {
    width: 100%;
    height: 100%;
  }

  .legend {
    position: absolute;
    top: 80px;
    right: 10px;
    background-color: white;
    display: flex;
    padding: 8px;

    .md-button {
      margin: 0;
      padding: 0;
      padding-right: 4px;
      width:100%;
      text-align: left;
      text-transform: none;
    }

    .legend-color {
      width: 18px;
      height: 18px;
      float: left;
      margin-right: 6px;
      margin-top: 9px;
      margin-left: 6px;
    }

    ul {
      list-style-type: none;
      padding-left: 0;
      margin-top: 0;
      margin-bottom: 0
    }

    .gradient {
      width: 30px;
      align-items: stretch;
      margin-top: 6px;
      margin-bottom: 6px;
    }
  }
}

.md-sidenav-content {
  .close-sidenav {
    position: absolute;
    right: -4px;
    top: 0;
    z-index: 1000;
    color: white;
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?56827aa9